/** Returns the current root font size in pixels (reads from the live DOM). */
export const getRootFontSize = (): number =>
  parseFloat(getComputedStyle(document.documentElement).fontSize);

/** Converts a rem value to pixels using the current root font size. */
export const remToPx = (rem: number): number => rem * getRootFontSize();

/** Converts a pixel value to rem using the current root font size. */
export const pxToRem = (px: number): number => px / getRootFontSize();
